import React, { useEffect } from 'react';
import PageHeader from '../components/PageHeader';
import SEO from '../components/SEO';
import { Users, MapPin, Waves } from 'lucide-react';
import { useSiteData } from '../lib/SiteDataContext';
import { useLang } from '../lib/LanguageContext';
import { resolveImage } from '../lib/api';

const AboutPage = () => {
  const { settings } = useSiteData();
  const { t } = useLang();
  const sp = settings?.state_profile || {};
  const about = settings?.about || {};
  const header = settings?.page_headers?.about || {};
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const mapImg = sp.map_image_url ? resolveImage(sp.map_image_url) : '';
  return (
    <>
      <SEO
        title="About the State"
        description={
          (about.paragraphs && about.paragraphs[0]) ||
          'Learn about the South East State of Somalia — its regions, population, coastline and people.'
        }
        keywords="About South East State, Somalia regions, Marka Cadeey, Somali state profile"
      />
      <PageHeader
        title={header.title || 'About the State'}
        subtitle={header.subtitle}
        crumbs={[{ label: 'About' }]}
      />
      <section className="bg-white py-14">
        <div className="mx-auto max-w-[1280px] px-6">
          <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-2">
            <div>
              {mapImg ? (
                <img src={mapImg} alt="State map" className="w-full rounded-lg border border-[#E6DDC8] shadow-md" />
              ) : (
                <div className="flex h-[360px] w-full items-center justify-center rounded-lg border border-[#E6DDC8] bg-[#FAF6EC] text-[#0B2545]/40">Map not set</div>
              )}
            </div>
            <div>
              <div className="mb-3 text-[12px] font-semibold uppercase tracking-[0.22em] text-[#C9A86A]">{t('Our State')}</div>
              <h2 className="font-serif text-3xl font-bold text-[#0B2545] md:text-[36px]">{about.headline}</h2>
              <div className="mt-4 h-[3px] w-16 bg-[#C9A86A]" />
              <div className="mt-6 space-y-5 text-[15px] leading-relaxed text-[#0B2545]/80">
                {(about.paragraphs || []).map((p, i) => <p key={i}>{p}</p>)}
              </div>
              <div className="mt-8 grid grid-cols-3 gap-3">
                <div className="rounded-lg border border-[#E6DDC8] bg-[#FAF6EC] p-4 text-center">
                  <Users size={20} className="mx-auto text-[#C9A86A]" />
                  <div className="mt-2 font-serif text-xl font-bold text-[#0B2545]">{sp.population}</div>
                  <div className="text-[11.5px] uppercase tracking-wide text-[#0B2545]/60">{t('Population')}</div>
                </div>
                <div className="rounded-lg border border-[#E6DDC8] bg-[#FAF6EC] p-4 text-center">
                  <MapPin size={20} className="mx-auto text-[#C9A86A]" />
                  <div className="mt-2 font-serif text-xl font-bold text-[#0B2545]">{sp.regions}</div>
                  <div className="text-[11.5px] uppercase tracking-wide text-[#0B2545]/60">{t('Regions')}</div>
                </div>
                <div className="rounded-lg border border-[#E6DDC8] bg-[#FAF6EC] p-4 text-center">
                  <Waves size={20} className="mx-auto text-[#C9A86A]" />
                  <div className="mt-2 font-serif text-base font-bold leading-tight text-[#0B2545]">{sp.coastline}</div>
                  <div className="text-[11.5px] uppercase tracking-wide text-[#0B2545]/60">{t('Coastline')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutPage;
